export default __webpack_public_path__ + "static/HP_Quick_Hit_Thumb-9554bbc3157341bf4c5228b3bb70d5ba.png";